<template>
  <div>
    <Header class="fixed-bar" style="z-index: 100" />
    <!-- #region 第一區塊 block1 小芋頭平台-->

    <div class="block1-bg overflow-hidden" :style="$store.state.signinStatus && $vuetify.breakpoint.width < 1280 ? { height: 'auto' } : {}">
      <v-container class="py-0">
        <v-row>
          <v-col cols="12" md="6" align="left" class="px-4 px-sm-6 px-md-4 pr-md-0 pr-sm-4">
            <div class="text-h5 text-sm-h4 text-md-h3 font-weight-black deep-purple--text text--darken-4 mt-8 mt-md-15" :style="$vuetify.breakpoint.width > 959.89 ? { lineHeight: '51px' } : $vuetify.breakpoint.width < 475 ? { lineHeight: '35px' } : { lineHeight: '51px' }">
              {{ block1.title }}
            </div>
            <div class="text-h5 text-sm-h4 text-md-h3 font-weight-black deep-purple--text text--darken-4" :style="$vuetify.breakpoint.width > 959.89 ? { lineHeight: '51px' } : $vuetify.breakpoint.width < 475 ? { lineHeight: '35px' } : { lineHeight: '51px' }">
              {{ block1.title2 }}
            </div>
            <div class="text-md-h5 my-6">
              {{ block1.desc }}
            </div>
            <v-btn color="primary" rounded x-large outlined class="shareBtn mr-2 mb-2" @click="GoRouter('Share')">
              <v-icon class="mr-1" size="20">mdi-share-variant</v-icon>
              <span class="font-weight-bold">分享小芋頭平台</span>
            </v-btn>
            <v-btn color="#1ba252" style="border-color: #1ba252" rounded x-large outlined class="shareBtn mb-2" @click="AddLine()">
              <v-img :src="lineLogo" width="20" hegiht="20" class="mr-1"></v-img>
              <span class="font-weight-bold">加入小芋頭平台LINE好友</span>
            </v-btn>
            <!-- <v-btn
              v-if="!$store.state.signinStatus"
              rounded
              x-large
              color="primary"
              :width="
                $vuetify.breakpoint.width > 959.89
                  ? '50%'
                  : $vuetify.breakpoint.width < 425
                  ? '100%'
                  : '40%'
              "
              @click="GoRouter(block1.btnUrl)"
            >
              <v-icon size="17" class="mr-2">mdi-arrow-right</v-icon>
              {{ block1.btnText }}
            </v-btn>

            <div
              v-if="!$store.state.signinStatus"
              class="d-sm-flex mt-6 mb-15 font-weight-black"
            >
              <div class="mr-6">
                <span class="green--text text-h6 font-weight-black">✓</span>
                {{ block1.item1 }}
              </div>
              <div>
                <span class="green--text text-h6 font-weight-black">✓</span
                >{{ block1.item2 }}
              </div>
            </div> -->
          </v-col>
          <v-col cols="12" md="6" class="px-0 d-flex align-center">
            <v-img v-if="$vuetify.breakpoint.width > 959.89" :src="block1.img" :position="$vuetify.breakpoint.width > 1240 ? '0 -30px' : '0 0px'"></v-img>

            <v-img v-else :src="block1.img2" contain></v-img>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <!-- #endregion -->
    <!-- #region 快速前往 -->
    <div v-if="!$store.state.signinStatus" align="center" class="pt-6">
      <div class="text-h5 font-weight-bold">{{ quickForward.title }}</div>
      <v-container class="py-6">
        <v-row class="d-flex justify-center">
          <v-col cols="4" md="3" class="pa-2" v-for="x in quickForward.items" :key="x.text">
            <v-hover v-slot="{ hover }">
              <v-card class="d-sm-flex pa-1 px-sm-3 py-sm-4 pa-md-5 justify-center justify-sm-start quick-go" :class="{ 'on-hover': hover }" elevation="0" @click="GoRouter(x.url)">
                <div align="center">
                  <v-img :src="x.img" width="38" height="38" contain></v-img>
                </div>
                <div class="ml-sm-3 mt-3 mt-sm-0" :align="$vuetify.breakpoint.width < 600 ? 'center' : 'left'">
                  <div class="text-body-2 font-weight-bold">{{ x.text }}</div>
                  <div class="d-none d-sm-flex text-body-2 text--secondary">
                    {{ x.desc }}
                  </div>
                </div>
              </v-card>
            </v-hover>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <!-- #endregion -->

    <!-- #region 軟體服務全方位通道 -->
    <!-- <v-container class="pt-10">
      <div align="center">
        <div class="text-h5 text-sm-h4 font-weight-bold mt-12">
          {{ block11.topTitle }}
        </div>
        <div class="text-sm-h6 mt-2">{{ block11.topDesc }}</div>
      </div>
    </v-container> -->
    <!-- #endregion -->

    <v-container class="pt-10">
      <div align="center">
        <!-- <v-img :src="pfLogo" contain width="60"></v-img> -->
        <div class="text-h4">平台服務項目如下</div>
      </div>
    </v-container>

    <!-- #region AI平台區塊 -->
    <v-container class="pt-10 pb-6">
      <div align="center" class="mb-5">
        <v-img :src="logo30" max-width="327"></v-img>
        <div class="ai-title d-flex text-left mt-4">免費金豐勞動法務AI智能諮詢系統(隨身LLA勞動法務顧問師，人資管理的最強大腦）</div>
        <div class="d-flex mt-5 text-left">
          <span class="mr-3">
            <v-icon small>mdi-check-circle</v-icon>
            個人名片
          </span>
          <span class="mr-3">
            <v-icon small>mdi-check-circle</v-icon>
            AI客服
          </span>
          <span>
            <v-icon small>mdi-check-circle</v-icon>
            智能培訓
          </span>
        </div>
        <div class="d-flex text-left mt-5 mb-4 ai-sub">平台將以業界最低價格協助企業進入AI企業領域，先登記先得優惠早鳥價！</div>

        <template>
          <v-row justify="center">
            <v-col cols="12" sm="6" md="4" v-for="x in blockAI" :key="x.title">
              <div class="ai-card pa-3">
                <div class="d-flex">
                  <div class="mr-2">
                    <v-img :src="x.icon" height="38" width="38" class="rounded-lg"></v-img>
                  </div>
                  <div class="d-flex text-left text-h6 font-weight-bold">
                    {{ x.title }}
                  </div>
                </div>
                <div class="my-2">
                  <v-img :src="x.img"></v-img>
                </div>
                <div class="mb-2">
                  <ul class="text-left" style="font-size: 18px">
                    <li v-for="(y, yi) in x.list" :key="yi + '_list'">
                      {{ y.text }}
                    </li>
                  </ul>
                </div>
                <div class="d-flex align-center rounded-lg bg-white pa-3" style="background-color: white">
                  <div class="ai-sub text-left mr-2">{{ x.footer }}</div>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" @click="GoRouter(x.url)">{{ x.btnText }}</v-btn>
                </div>
              </div>
            </v-col>
          </v-row>
        </template>
      </div>
    </v-container>
    <!-- #endregion -->

    <!-- #region 企業經營 -->
    <div class="d-flex justify-center">
      <div class="home-block">
        <div class="py-0 pb-10">
          <div class="d-flex justify-center">
            <div class="home-block-icon-bg">
              <v-icon color="#304FFE">mdi-domain</v-icon>
            </div>
          </div>
          <div align="center" class="d-flex align-center">
            <v-divider></v-divider>
            <div class="mx-6 my-4 text-h4 text-md-h2 font-weight-bold home-subtitle">
              <span>企業經營</span>
            </div>
            <v-divider></v-divider>
          </div>
          <div class="blue--text blue-accent-3 text-center">BUSINESS MANAGEMENT</div>
        </div>
      </div>
    </div>
    <!-- #endregion -->

    <!-- #region 第四區塊 block4 小芋頭廣告-->
    <v-container class="py-10">
      <v-row>
        <v-col cols="12" md="6" align="left" class="px-4 px-sm-10 pr-md-10">
          <div class="px-0 px-sm-10 px-md-0">
            <div class="text-h5 text-md-h4 font-weight-bold mt-6 deep-purple--text text--darken-4" :style="$vuetify.breakpoint.width < 960 ? { lineHeight: '35px' } : { lineHeight: '51px' }">
              {{ block4.title }}
            </div>
            <div class="d-flex my-3">
              <div>
                <v-icon small>mdi-check-circle</v-icon>
                {{ block4.item1 }}
              </div>
              <div class="mx-3">
                <v-icon small>mdi-check-circle</v-icon>
                {{ block4.item2 }}
              </div>
              <!-- <div>
                <v-icon small>mdi-check-circle</v-icon>{{ block4.item3 }}
              </div> -->
            </div>
            <ol>
              <li class="text-h6">
                {{ block4.desc }}
              </li>
              <li class="text-h6">
                {{ block4.desc2 }}
              </li>
            </ol>
            <v-btn x-large color="primary" rounded class="my-6" @click="GoRouter(block4.btnUrl)">
              <v-icon size="17" class="mr-2">mdi-arrow-right</v-icon>
              {{ block4.btnText }}
            </v-btn>
          </div>
        </v-col>
        <v-col cols="12" md="6" class="d-flex align-center px-4 px-sm-10 pl-md-10">
          <v-img :src="block4.img" contain class="px-0 px-sm-10 px-md-0"></v-img>
        </v-col>
      </v-row>
    </v-container>
    <!-- #endregion -->

    <!-- #region 第二區塊 block2 小芋頭社群-->
    <v-container>
      <v-row class="py-10">
        <v-col cols="12" md="6" align="left" class="px-4 px-sm-10 pr-md-10">
          <div class="px-0 px-sm-10 px-md-0">
            <div class="text-h5 text-md-h4 font-weight-bold mt-6 deep-purple--text text--darken-4" :style="$vuetify.breakpoint.width < 960 ? { lineHeight: '35px' } : { lineHeight: '51px' }">
              {{ block2.title }}
            </div>
            <div class="d-flex my-3">
              <div class="mr-3">
                <v-icon small>mdi-check-circle</v-icon>
                {{ block2.item1 }}
              </div>
              <div>
                <v-icon small>mdi-check-circle</v-icon>
                {{ block2.item2 }}
              </div>
            </div>
            <ol>
              <li class="text-h6">
                {{ block2.desc }}
              </li>
              <li class="text-h6">
                {{ block2.desc2 }}
              </li>
              <li class="text-h6">
                {{ block2.desc3 }}
              </li>
              <li class="text-h6">
                {{ block2.desc4 }}
              </li>
            </ol>
            <v-btn x-large color="primary" rounded class="my-6" @click="GoRouter(block2.btnUrl)">
              <v-icon size="17" class="mr-2">mdi-arrow-right</v-icon>
              {{ block2.btnText }}
            </v-btn>
          </div>
        </v-col>
        <v-col cols="12" md="6" class="d-flex align-center px-4 px-sm-10 pl-md-10">
          <v-img :src="block2.img" contain class="px-0 px-sm-10 px-md-0"></v-img>
        </v-col>
      </v-row>
    </v-container>
    <!-- #endregion  -->

    <!-- #region 第四之二區塊 block42 免費勞動法務檢查及顧問諮詢服務-->
    <div>
      <v-container>
        <v-row class="py-10">
          <v-col cols="12" md="6" class="px-4 px-sm-10 pl-md-10" align="left">
            <div class="px-0 px-sm-10 px-md-0">
              <div class="text-h5 text-md-h4 font-weight-bold mt-6 deep-purple--text text--darken-4" :style="$vuetify.breakpoint.width < 960 ? { lineHeight: '35px' } : { lineHeight: '51px' }">
                {{ block42.title }}
              </div>

              <div class="d-flex my-3">
                <div class="mr-3">
                  <v-icon small>mdi-check-circle</v-icon>
                  {{ block42.item1 }}
                </div>
              </div>
              <ol>
                <li class="text-h6">
                  {{ block42.desc }}
                </li>
                <li class="text-h6">
                  {{ block42.desc2 }}
                </li>
                <li class="text-h6">
                  {{ block42.desc3 }}
                </li>
              </ol>

              <v-btn x-large color="primary" rounded class="my-6" @click="GoRouter(block42.btnUrl)">
                <v-icon size="17" class="mr-2">mdi-arrow-right</v-icon>
                <span>
                  {{ block42.btnText }}
                </span>
              </v-btn>
            </div>
          </v-col>
          <v-col v-if="$vuetify.breakpoint.width < 960" cols="12" md="6" align="left" class="px-4 px-sm-10 pr-md-10">
            <div class="px-0 px-sm-10 px-md-0">
              <v-img :src="block42.img"></v-img>
            </div>
          </v-col>
          <v-col v-if="$vuetify.breakpoint.width > 959.98" cols="12" md="6" align="left" class="d-flex align-center px-4 px-sm-10 pr-md-10">
            <v-img :src="block42.img" class="px-0 px-sm-10 px-md-0"></v-img>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <!-- #endregion -->

    <!-- #region 第四之十區塊 block410 -->
    <div>
      <v-container>
        <v-row class="py-10">
          <v-col cols="12" md="6" class="px-4 px-sm-10 pl-md-10" align="left">
            <div class="px-0 px-sm-10 px-md-0">
              <div class="text-h5 text-md-h4 font-weight-bold mt-6 deep-purple--text text--darken-4" :style="$vuetify.breakpoint.width < 960 ? { lineHeight: '35px' } : { lineHeight: '51px' }">
                {{ block410.title }}
              </div>

              <div class="d-flex my-3">
                <div class="mr-3">
                  <v-icon small>mdi-check-circle</v-icon>
                  {{ block410.item1 }}
                </div>
              </div>
              <ol>
                <li class="text-h6">
                  {{ block410.desc }}
                </li>
                <li class="text-h6">
                  {{ block410.desc2 }}
                </li>
                <li class="text-h6">
                  {{ block410.desc3 }}
                </li>
              </ol>

              <v-btn x-large color="primary" rounded class="my-6" @click="GoRouter(block410.btnUrl)" style="display: inline-flex; flex-direction: column; align-items: center; white-space: normal">
                <v-icon size="17" class="mr-2">mdi-arrow-right</v-icon>

                <span style="white-space: normal; text-align: center">
                  {{ block410.btnText }}
                </span>
              </v-btn>
            </div>
          </v-col>
          <v-col v-if="$vuetify.breakpoint.width < 960" cols="12" md="6" align="left" class="px-4 px-sm-10 pr-md-10">
            <div class="px-0 px-sm-10 px-md-0">
              <v-img :src="block410.img"></v-img>
            </div>
          </v-col>
          <v-col v-if="$vuetify.breakpoint.width > 959.98" cols="12" md="6" align="left" class="d-flex align-center px-4 px-sm-10 pr-md-10">
            <v-img :src="block410.img" class="px-0 px-sm-10 px-md-0"></v-img>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <!-- #endregion -->

    <!-- #region 培訓考證 -->
    <div class="d-flex justify-center">
      <div class="home-block">
        <div class="py-0 pb-10">
          <div class="d-flex justify-center">
            <div class="home-block-icon-bg">
              <v-icon color="#304FFE">mdi-domain</v-icon>
            </div>
          </div>
          <div align="center" class="d-flex align-center">
            <v-divider></v-divider>
            <div class="mx-6 my-4 text-h4 text-md-h2 font-weight-bold home-subtitle">
              <span>培訓考證</span>
            </div>
            <v-divider></v-divider>
          </div>
          <div class="blue--text blue-accent-3 text-center">TRAINING AND CERTIFICATION</div>
        </div>
      </div>
    </div>
    <!-- #endregion -->

    <!-- #region 第四之七區塊 block47 金豐企業大學專家講師系列講座-->
    <v-container>
      <v-row class="py-10">
        <v-col cols="12" md="6" class="px-4 px-sm-10 pl-md-10" align="left">
          <div class="px-0 px-sm-10 px-md-0">
            <div class="text-h5 text-md-h4 font-weight-bold mt-6 deep-purple--text text--darken-4" :style="$vuetify.breakpoint.width < 960 ? { lineHeight: '35px' } : { lineHeight: '51px' }">
              {{ block47.title }}
            </div>
            <div class="d-flex my-3">
              <v-icon small>mdi-check-circle</v-icon>
              {{ block47.item1 }}
            </div>
            <ol>
              <li class="text-h6">
                {{ block47.desc }}
              </li>
              <li class="text-h6">
                {{ block47.desc2 }}
              </li>
              <li class="text-h6">
                {{ block47.desc3 }}
              </li>
            </ol>
            <v-btn x-large color="primary" rounded class="my-6" @click="GoRouter(block47.btnUrl)">
              <v-icon size="17" class="mr-2">mdi-arrow-right</v-icon>
              <span>
                {{ block47.btnText }}
              </span>
            </v-btn>
          </div>
        </v-col>
        <v-col v-if="$vuetify.breakpoint.width > 959.98" cols="12" md="6" align="left" class="d-flex align-center px-4 px-sm-10 pr-md-10">
          <v-img :src="block47.img" class="px-0 px-sm-10 px-md-0"></v-img>
        </v-col>
        <v-col v-if="$vuetify.breakpoint.width < 960" cols="12" md="6" align="left" class="px-4 px-sm-10 pr-md-10">
          <div class="px-0 px-sm-10 px-md-0">
            <v-img :src="block47.img"></v-img>
          </div>
        </v-col>
      </v-row>
    </v-container>
    <!-- #endregion -->

    <!-- #region 第四之九區塊 block49 -->
    <v-container>
      <v-row class="py-10">
        <v-col cols="12" md="6" class="px-4 px-sm-10 pl-md-10" align="left">
          <div class="px-0 px-sm-10 px-md-0">
            <div class="text-h5 text-md-h4 font-weight-bold mt-6 deep-purple--text text--darken-4" :style="$vuetify.breakpoint.width < 960 ? { lineHeight: '35px' } : { lineHeight: '51px' }">
              {{ block49.title }}
            </div>
            <div class="d-flex my-3">
              <v-icon small>mdi-check-circle</v-icon>
              {{ block49.item1 }}
            </div>
            <ol>
              <li class="text-h6">
                {{ block49.desc }}
              </li>
              <li class="text-h6">
                {{ block49.desc2 }}
              </li>
              <li class="text-h6">
                {{ block49.desc3 }}
              </li>
              <li class="text-h6">
                {{ block49.desc4 }}
              </li>
            </ol>
            <v-btn x-large color="primary" rounded class="my-6" @click="GoRouter(block49.btnUrl)">
              <v-icon size="17" class="mr-2">mdi-arrow-right</v-icon>
              <span>
                {{ block49.btnText }}
              </span>
            </v-btn>
          </div>
        </v-col>
        <v-col v-if="$vuetify.breakpoint.width > 959.98" cols="12" md="6" align="left" class="d-flex align-center px-4 px-sm-10 pr-md-10">
          <v-img :src="block49.img" class="px-0 px-sm-10 px-md-0"></v-img>
        </v-col>
        <v-col v-if="$vuetify.breakpoint.width < 960" cols="12" md="6" align="left" class="px-4 px-sm-10 pr-md-10">
          <div class="px-0 px-sm-10 px-md-0">
            <v-img :src="block49.img"></v-img>
          </div>
        </v-col>
      </v-row>
    </v-container>
    <!-- #endregion -->

    <!-- #region 第四之六區塊 block46 免費企業勞動法務基礎實務考證班培訓-->
    <v-container>
      <v-row class="py-10">
        <v-col cols="12" md="6" class="px-4 px-sm-10 pl-md-10" align="left">
          <div class="px-0 px-sm-10 px-md-0">
            <div class="text-h5 text-md-h4 font-weight-bold mt-6 deep-purple--text text--darken-4" :style="$vuetify.breakpoint.width < 960 ? { lineHeight: '35px' } : { lineHeight: '51px' }">
              {{ block46.title }}
            </div>
            <div class="d-flex my-3">
              <v-icon small>mdi-check-circle</v-icon>
              {{ block46.item1 }}
            </div>
            <ol>
              <li class="text-h6">
                {{ block46.desc }}
              </li>
              <li class="text-h6">
                {{ block46.desc2 }}
              </li>
              <li class="text-h6">
                {{ block46.desc3 }}
              </li>
              <li class="text-h6">
                {{ block46.desc4 }}
              </li>
              <li class="text-h6">
                {{ block46.desc5 }}
              </li>
            </ol>
            <v-btn x-large color="primary" rounded class="my-6" @click="GoRouter(block46.btnUrl)">
              <v-icon size="17" class="mr-2">mdi-arrow-right</v-icon>
              <span>
                {{ block46.btnText }}
              </span>
            </v-btn>
          </div>
        </v-col>
        <v-col v-if="$vuetify.breakpoint.width > 959.98" cols="12" md="6" align="left" class="d-flex align-center px-4 px-sm-10 pr-md-10">
          <v-img :src="block46.img" class="px-0 px-sm-10 px-md-0"></v-img>
        </v-col>
        <v-col v-if="$vuetify.breakpoint.width < 960" cols="12" md="6" align="left" class="px-4 px-sm-10 pr-md-10">
          <div class="px-0 px-sm-10 px-md-0">
            <v-img :src="block46.img"></v-img>
          </div>
        </v-col>
      </v-row>
    </v-container>
    <!-- #endregion -->

    <!-- #region 第四之一區塊 block41 性騷擾申訴-->
    <v-container>
      <v-row class="py-10">
        <v-col cols="12" md="6" class="px-4 px-sm-10 pl-md-10" align="left">
          <div class="px-0 px-sm-10 px-md-0">
            <div class="text-h5 text-md-h4 font-weight-bold mt-6 deep-purple--text text--darken-4" :style="$vuetify.breakpoint.width < 960 ? { lineHeight: '35px' } : { lineHeight: '51px' }">
              {{ block41.title }}
            </div>
            <div class="d-flex my-3">
              <v-icon small>mdi-check-circle</v-icon>
              {{ block41.item1 }}
            </div>

            <ol>
              <li class="text-h6">
                {{ block41.desc }}
              </li>
              <li class="text-h6">
                {{ block41.desc2 }}
              </li>
              <li class="text-h6">
                {{ block41.desc3 }}
              </li>
              <li class="text-h6">
                {{ block41.desc4 }}
              </li>
            </ol>

            <v-btn x-large color="primary" rounded class="my-6" @click="GoRouter(block41.btnUrl)">
              <v-icon size="17" class="mr-2">mdi-arrow-right</v-icon>
              <span>
                {{ block41.btnText }}
              </span>
            </v-btn>
          </div>
        </v-col>
        <v-col v-if="$vuetify.breakpoint.width > 959.98" cols="12" md="6" align="left" class="d-flex align-center px-4 px-sm-10 pr-md-10">
          <v-img :src="block41.img" class="px-0 px-sm-10 px-md-0"></v-img>
        </v-col>
        <v-col v-if="$vuetify.breakpoint.width < 960" cols="12" md="6" align="left" class="px-4 px-sm-10 pr-md-10">
          <div class="px-0 px-sm-10 px-md-0">
            <v-img :src="block41.img"></v-img>
          </div>
        </v-col>
      </v-row>
    </v-container>
    <!-- #endregion -->

    <!-- #region 策略合作 -->
    <div class="d-flex justify-center">
      <div class="home-block">
        <div class="py-0 pb-10">
          <div class="d-flex justify-center">
            <div class="home-block-icon-bg">
              <v-icon color="#304FFE">mdi-domain</v-icon>
            </div>
          </div>
          <div align="center" class="d-flex align-center">
            <v-divider></v-divider>
            <div class="mx-6 my-4 text-h4 text-md-h2 font-weight-bold home-subtitle">
              <span>策略合作</span>
            </div>
            <v-divider></v-divider>
          </div>
          <div class="blue--text blue-accent-3 text-center">STRATEGIC COOPERATION</div>
        </div>
      </div>
    </div>
    <!-- endregion -->

    <!-- #region 第四之三區塊 block43 免費法律諮詢申請-->
    <v-container>
      <v-row class="py-10">
        <v-col cols="12" md="6" class="px-4 px-sm-10 pl-md-10" align="left">
          <div class="px-0 px-sm-10 px-md-0">
            <div class="text-h5 text-md-h4 font-weight-bold mt-6 deep-purple--text text--darken-4" :style="$vuetify.breakpoint.width < 960 ? { lineHeight: '35px' } : { lineHeight: '51px' }">
              {{ block43.title }}
            </div>
            <div class="d-flex my-3">
              <div class="mr-3">
                <v-icon small>mdi-check-circle</v-icon>
                {{ block43.item1 }}
              </div>
            </div>
            <ol>
              <li class="text-h6">
                {{ block43.desc }}
              </li>
              <li class="text-h6">
                {{ block43.desc2 }}
              </li>
              <li class="text-h6">
                {{ block43.desc3 }}
              </li>
            </ol>
            <v-btn x-large color="primary" rounded class="my-6" @click="GoRouter(block43.btnUrl)" style="display: inline-flex; flex-direction: column; align-items: left; white-space: normal">
              <v-icon size="17" class="mr-2">mdi-arrow-right</v-icon>
              <span style="width: 100%; text-align: left">
                {{ block43.btnText }}
              </span>
            </v-btn>
          </div>
        </v-col>
        <v-col v-if="$vuetify.breakpoint.width > 959.98" cols="12" md="6" align="left" class="d-flex align-center px-4 px-sm-10 pr-md-10">
          <v-img :src="block43.img" class="px-0 px-sm-10 px-md-0"></v-img>
        </v-col>
        <v-col v-if="$vuetify.breakpoint.width < 960" cols="12" md="6" align="left" class="px-4 px-sm-10 pr-md-10">
          <div class="px-0 px-sm-10 px-md-0">
            <v-img :src="block43.img"></v-img>
          </div>
        </v-col>
      </v-row>
    </v-container>
    <!-- #endregion -->

    <!-- #region 第四之四區塊 block44 免費ESG資安診斷服務申請-->
    <v-container>
      <v-row class="py-10">
        <v-col cols="12" md="6" class="px-4 px-sm-10 pl-md-10" align="left">
          <div class="px-0 px-sm-10 px-md-0">
            <div class="text-h5 text-md-h4 font-weight-bold mt-6 deep-purple--text text--darken-4" :style="$vuetify.breakpoint.width < 960 ? { lineHeight: '35px' } : { lineHeight: '51px' }">
              {{ block44.title }}
            </div>
            <div class="d-flex my-3">
              <div class="mr-3">
                <v-icon small>mdi-check-circle</v-icon>
                {{ block44.item1 }}
              </div>
            </div>
            <ol>
              <li class="text-h6">
                {{ block44.desc }}
              </li>
              <li class="text-h6">
                {{ block44.desc2 }}
              </li>
              <li class="text-h6">
                {{ block44.desc3 }}
              </li>
            </ol>
            <v-btn x-large color="primary" rounded class="my-6" @click="GoRouter(block44.btnUrl)" style="display: inline-flex; flex-direction: column; align-items: left; white-space: normal">
              <v-icon size="17" class="mr-2">mdi-arrow-right</v-icon>
              <span style="width: 100%; text-align: left">
                {{ block44.btnText }}
              </span>
            </v-btn>
          </div>
        </v-col>
        <v-col v-if="$vuetify.breakpoint.width > 959.98" cols="12" md="6" align="left" class="d-flex align-center px-4 px-sm-10 pr-md-10">
          <v-img :src="block44.img" class="px-0 px-sm-10 px-md-0"></v-img>
        </v-col>
        <v-col v-if="$vuetify.breakpoint.width < 960" cols="12" md="6" align="left" class="px-4 px-sm-10 pr-md-10">
          <div class="px-0 px-sm-10 px-md-0">
            <v-img :src="block44.img"></v-img>
          </div>
        </v-col>
      </v-row>
    </v-container>
    <!-- #endregion -->

    <!-- #region 第四之十一區塊 block411 免費ESG碳排查及認證諮詢-->
    <v-container>
      <v-row class="py-10">
        <v-col cols="12" md="6" class="px-4 px-sm-10 pl-md-10" align="left">
          <div class="px-0 px-sm-10 px-md-0">
            <div class="text-h5 text-md-h4 font-weight-bold mt-6 deep-purple--text text--darken-4" :style="$vuetify.breakpoint.width < 960 ? { lineHeight: '35px' } : { lineHeight: '51px' }">
              {{ block411.title }}
            </div>
            <div class="d-flex my-3">
              <div class="mr-3">
                <v-icon small>mdi-check-circle</v-icon>
                {{ block411.item1 }}
              </div>
            </div>
            <ol>
              <li class="text-h6">
                {{ block411.desc }}
              </li>
              <li class="text-h6">
                {{ block411.desc2 }}
              </li>
            </ol>
            <v-btn x-large color="primary" rounded class="my-6" @click="GoRouter(block411.btnUrl)" style="display: inline-flex; flex-direction: column; align-items: left; white-space: normal">
              <v-icon size="17" class="mr-2">mdi-arrow-right</v-icon>
              <span style="width: 100%; text-align: left">
                {{ block411.btnText }}
              </span>
            </v-btn>
          </div>
        </v-col>
        <v-col v-if="$vuetify.breakpoint.width > 959.98" cols="12" md="6" align="left" class="d-flex align-center px-4 px-sm-10 pr-md-10">
          <v-img :src="block411.img" class="px-0 px-sm-10 px-md-0"></v-img>
        </v-col>
        <v-col v-if="$vuetify.breakpoint.width < 960" cols="12" md="6" align="left" class="px-4 px-sm-10 pr-md-10">
          <div class="px-0 px-sm-10 px-md-0">
            <v-img :src="block411.img"></v-img>
          </div>
        </v-col>
      </v-row>
    </v-container>
    <!-- #endregion -->

    <!-- #region 第四之五區塊 block45 免費ESG節能減碳企業補助服務申請-->
    <v-container>
      <v-row class="py-10">
        <v-col cols="12" md="6" class="px-4 px-sm-10 pl-md-10" align="left">
          <div class="px-0 px-sm-10 px-md-0">
            <div class="text-h5 text-md-h4 font-weight-bold mt-6 deep-purple--text text--darken-4" :style="$vuetify.breakpoint.width < 960 ? { lineHeight: '35px' } : { lineHeight: '51px' }">
              {{ block45.title }}
            </div>
            <div class="d-flex my-3">
              <div class="mr-3">
                <v-icon small>mdi-check-circle</v-icon>
                {{ block45.item1 }}
              </div>
            </div>
            <ol>
              <li class="text-h6">
                {{ block45.desc }}
              </li>
              <li class="text-h6">
                {{ block45.desc2 }}
              </li>
            </ol>
            <v-btn x-large color="primary" rounded class="my-6" @click="GoRouter(block45.btnUrl)" style="display: inline-flex; flex-direction: column; align-items: left; white-space: normal">
              <v-icon size="17" class="mr-2">mdi-arrow-right</v-icon>
              <span style="width: 100%; text-align: left">
                {{ block45.btnText }}
              </span>
            </v-btn>
          </div>
        </v-col>
        <v-col v-if="$vuetify.breakpoint.width > 959.98" cols="12" md="6" align="left" class="d-flex align-center px-4 px-sm-10 pr-md-10">
          <v-img :src="block45.img" class="px-0 px-sm-10 px-md-0"></v-img>
        </v-col>
        <v-col v-if="$vuetify.breakpoint.width < 960" cols="12" md="6" align="left" class="px-4 px-sm-10 pr-md-10">
          <div class="px-0 px-sm-10 px-md-0">
            <v-img :src="block45.img"></v-img>
          </div>
        </v-col>
      </v-row>
    </v-container>
    <!-- #endregion -->

    <!-- #region 第四之八區塊 block48 -->
    <v-container>
      <v-row class="py-10">
        <v-col cols="12" md="6" class="px-4 px-sm-10 pl-md-10" align="left">
          <div class="px-0 px-sm-10 px-md-0">
            <div class="text-h5 text-md-h4 font-weight-bold mt-6 deep-purple--text text--darken-4" :style="$vuetify.breakpoint.width < 960 ? { lineHeight: '35px' } : { lineHeight: '51px' }">
              {{ block48.title }}
            </div>
            <div class="d-flex my-3">
              <div class="mr-3">
                <v-icon small>mdi-check-circle</v-icon>
                {{ block45.item1 }}
              </div>
            </div>
            <ol>
              <li class="text-h6">
                {{ block48.desc }}
              </li>
              <li class="text-h6">
                {{ block48.desc2 }}
              </li>
            </ol>
            <v-btn x-large color="primary" rounded class="my-6" @click="GoRouter(block48.btnUrl)" style="display: inline-flex; flex-direction: column; align-items: left; white-space: normal">
              <v-icon size="17" class="mr-2">mdi-arrow-right</v-icon>
              <span style="width: 100%; text-align: left">
                {{ block48.btnText }}
              </span>
            </v-btn>
          </div>
        </v-col>
        <v-col v-if="$vuetify.breakpoint.width > 959.98" cols="12" md="6" align="left" class="d-flex align-center px-4 px-sm-10 pr-md-10">
          <v-img :src="block48.img" class="px-0 px-sm-10 px-md-0"></v-img>
        </v-col>
        <v-col v-if="$vuetify.breakpoint.width < 960" cols="12" md="6" align="left" class="px-4 px-sm-10 pr-md-10">
          <div class="px-0 px-sm-10 px-md-0">
            <v-img :src="block48.img"></v-img>
          </div>
        </v-col>
      </v-row>
    </v-container>
    <!-- #endregion -->

    <!-- #region 第四之十二區塊 block412 -->
    <v-container>
      <v-row class="py-10">
        <v-col cols="12" md="6" class="px-4 px-sm-10 pl-md-10" align="left">
          <div class="px-0 px-sm-10 px-md-0">
            <div class="text-h5 text-md-h4 font-weight-bold mt-6 deep-purple--text text--darken-4" :style="$vuetify.breakpoint.width < 960 ? { lineHeight: '35px' } : { lineHeight: '51px' }">
              {{ block412.title }}
            </div>
            <div class="d-flex my-3">
              <div class="mr-3">
                <v-icon small>mdi-check-circle</v-icon>
                {{ block45.item1 }}
              </div>
            </div>
            <ol>
              <li class="text-h6">
                {{ block412.desc }}
              </li>
              <li class="text-h6">
                {{ block412.desc2 }}
              </li>
              <li class="text-h6">
                {{ block412.desc3 }}
              </li>
              <li class="text-h6">
                {{ block412.desc4 }}
              </li>
            </ol>
            <v-btn x-large color="primary" rounded class="my-6" @click="GoRouter(block412.btnUrl)" style="display: inline-flex; flex-direction: column; align-items: left; white-space: normal">
              <v-icon size="17" class="mr-2">mdi-arrow-right</v-icon>
              <span style="width: 100%; text-align: left">
                {{ block412.btnText }}
              </span>
            </v-btn>
          </div>
        </v-col>
        <v-col v-if="$vuetify.breakpoint.width > 959.98" cols="12" md="6" align="left" class="d-flex align-center px-4 px-sm-10 pr-md-10">
          <v-img :src="block412.img" class="px-0 px-sm-10 px-md-0"></v-img>
        </v-col>
        <v-col v-if="$vuetify.breakpoint.width < 960" cols="12" md="6" align="left" class="px-4 px-sm-10 pr-md-10">
          <div class="px-0 px-sm-10 px-md-0">
            <v-img :src="block412.img"></v-img>
          </div>
        </v-col>
      </v-row>
    </v-container>
    <!-- #endregion -->

    <!-- #region 第四之十三區塊 block413 -->
    <v-container>
      <v-row class="py-10">
        <v-col cols="12" md="6" class="px-4 px-sm-10 pl-md-10" align="left">
          <div class="px-0 px-sm-10 px-md-0">
            <div class="text-h5 text-md-h4 font-weight-bold mt-6 deep-purple--text text--darken-4" :style="$vuetify.breakpoint.width < 960 ? { lineHeight: '35px' } : { lineHeight: '51px' }">
              {{ block413.title }}
            </div>
            <div class="d-flex my-3">
              <div class="mr-3">
                <v-icon small>mdi-check-circle</v-icon>
                {{ block45.item1 }}
              </div>
            </div>
            <ol>
              <li class="text-h6">
                {{ block413.desc }}
              </li>
              <li class="text-h6">
                {{ block413.desc2 }}
              </li>
              <li class="text-h6">
                {{ block413.desc3 }}
              </li>
              <li class="text-h6">
                {{ block413.desc4 }}
              </li>
            </ol>
            <v-btn x-large color="primary" rounded class="my-6" @click="GoRouter(block413.btnUrl)" style="display: inline-flex; flex-direction: column; align-items: left; white-space: normal">
              <v-icon size="17" class="mr-2">mdi-arrow-right</v-icon>
              <span style="width: 100%; text-align: left">
                {{ block413.btnText }}
              </span>
            </v-btn>
          </div>
        </v-col>
        <v-col v-if="$vuetify.breakpoint.width > 959.98" cols="12" md="6" align="left" class="d-flex align-center px-4 px-sm-10 pr-md-10">
          <v-img :src="block413.img" class="px-0 px-sm-10 px-md-0"></v-img>
        </v-col>
        <v-col v-if="$vuetify.breakpoint.width < 960" cols="12" md="6" align="left" class="px-4 px-sm-10 pr-md-10">
          <div class="px-0 px-sm-10 px-md-0">
            <v-img :src="block413.img"></v-img>
          </div>
        </v-col>
      </v-row>
    </v-container>
    <!-- #endregion -->

    <!-- #region 第四之十三區塊 block414 -->
    <v-container>
      <v-row class="py-10">
        <v-col cols="12" md="6" class="px-4 px-sm-10 pl-md-10" align="left">
          <div class="px-0 px-sm-10 px-md-0">
            <div class="text-h5 text-md-h4 font-weight-bold mt-6 deep-purple--text text--darken-4" :style="$vuetify.breakpoint.width < 960 ? { lineHeight: '35px' } : { lineHeight: '51px' }">
              {{ block414.title }}
            </div>
            <div class="d-flex my-3">
              <div class="mr-3">
                <v-icon small>mdi-check-circle</v-icon>
                {{ block45.item1 }}
              </div>
            </div>
            <ol>
              <li class="text-h6">
                {{ block414.desc }}
              </li>
              <li class="text-h6">
                {{ block414.desc2 }}
              </li>
              <li class="text-h6">
                {{ block414.desc3 }}
              </li>
            </ol>
            <v-btn x-large color="primary" rounded class="my-6" @click="GoRouter(block414.btnUrl)" style="display: inline-flex; flex-direction: column; align-items: left; white-space: normal">
              <v-icon size="17" class="mr-2">mdi-arrow-right</v-icon>
              <span style="width: 100%; text-align: left">
                {{ block414.btnText }}
              </span>
            </v-btn>
          </div>
        </v-col>
        <v-col v-if="$vuetify.breakpoint.width > 959.98" cols="12" md="6" align="left" class="d-flex align-center px-4 px-sm-10 pr-md-10">
          <v-img :src="block414.img" class="px-0 px-sm-10 px-md-0"></v-img>
        </v-col>
        <v-col v-if="$vuetify.breakpoint.width < 960" cols="12" md="6" align="left" class="px-4 px-sm-10 pr-md-10">
          <div class="px-0 px-sm-10 px-md-0">
            <v-img :src="block414.img"></v-img>
          </div>
        </v-col>
      </v-row>
    </v-container>
    <!-- #endregion -->

    <!-- #region 第三區塊 block3 汪汪工作站-->
    <div style="background-color: #faf8f5">
      <v-container>
        <v-row>
          <v-col cols="12" md="6" class="px-4 px-sm-10 pl-md-10" align="left">
            <div class="px-0 px-sm-10 px-md-0">
              <div class="text-h5 text-md-h4 font-weight-bold mt-6 deep-purple--text text--darken-4" :style="$vuetify.breakpoint.width < 960 ? { lineHeight: '35px' } : { lineHeight: '51px' }">
                {{ block3.title }}
              </div>
              <div class="d-flex my-3">
                <div>
                  <v-icon small>mdi-check-circle</v-icon>
                  {{ block3.item1 }}
                </div>
                <div class="mx-3">
                  <v-icon small>mdi-check-circle</v-icon>
                  {{ block3.item2 }}
                </div>
                <div>
                  <v-icon small>mdi-check-circle</v-icon>
                  {{ block3.item3 }}
                </div>
              </div>
              <div class="text-h6">{{ block3.desc }}</div>
              <!-- <div class="my-6 text-h5 text--secondary font-weight-bold">
                {{ block3.btnText }}
              </div> -->
              <v-btn x-large color="#00000061" rounded class="my-6">
                <v-icon size="17" class="mr-2" color="white">mdi-arrow-right</v-icon>
                <span class="white--text">
                  {{ block3.btnText }}
                </span>
              </v-btn>
            </div>
          </v-col>
          <v-col v-if="$vuetify.breakpoint.width > 959.98" cols="12" md="6" align="left" class="d-flex align-center px-4 px-sm-10 pr-md-10">
            <v-img :src="block3.img" class="px-0 px-sm-10 px-md-0"></v-img>
          </v-col>
          <v-col v-if="$vuetify.breakpoint.width < 960" cols="12" md="6" align="left" class="px-4 px-sm-10 pr-md-10">
            <div class="px-0 px-sm-10 px-md-0">
              <v-img :src="block3.img"></v-img>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </div>

    <!-- #endregion -->

    <!-- #region 第五區塊 block5 快速註冊啟用-->
    <v-container class="py-10 px-4 px-sm-6">
      <div class="text-h5 text-md-h4 font-weight-bold mb-2 deep-purple--text text--darken-4" :style="$vuetify.breakpoint.width < 960 ? { lineHeight: '35px' } : { lineHeight: '52px' }">
        {{ block5.title }}
      </div>
      <!-- <div class="text-md-h6 mb-6">{{ block5.desc }}</div> -->
      <v-row class="mb-10">
        <v-col cols="6" md="4" v-for="(x, index) in block5.items" :key="index" align="left">
          <div class="d-flex align-center" align="left">
            <div>
              <v-img :src="x.icon" contain width="60" height="60"></v-img>
            </div>
            <template v-if="index + 1 < block5.items.length" class="my-4">
              <v-img :src="x.arraw" contain max-width="40" class="ml-6"></v-img>
            </template>
          </div>
          <div class="mb-2 text-md-h6 font-weight-bold">{{ x.text }}</div>
          <div class="text-md-h6">{{ x.desc }}</div>
          <div></div>
        </v-col>
      </v-row>
    </v-container>
    <!-- #endregion -->

    <!-- #region 第六區塊 block6 立即註冊-->
    <!-- <div
      v-if="!$store.state.signinStatus"
      class="py-15"
      style="background-color: #27214e"
    >
      <v-container class="px-4">
        <div
          class="text-h5 text-md-h4 font-weight-bold mb-8 white--text"
          :style="
            $vuetify.breakpoint.width < 960
              ? { lineHeight: '35px' }
              : { lineHeight: '52px' }
          "
        >
          {{ block6.title }}
        </div>
        <v-btn
          x-large
          color="primary"
          rounded
          :width="
            $vuetify.breakpoint.width > 960
              ? '20%'
              : $vuetify.breakpoint.width < 425
              ? '100%'
              : '40%'
          "
          @click="GoRouter(block6.btnUrl)"
        >
          <v-icon size="17" class="mr-2">mdi-arrow-right</v-icon>
          {{ block6.btnText }}
        </v-btn>
      </v-container>
    </div> -->
    <!-- #endregion -->

    <!-- #region 第七區塊 block7 Footer-->
    <div class="py-10 white--text" style="background-color: #19191b">
      <v-container>
        <v-row>
          <v-col cols="12" md="4" align="left" class="mt-6 pr-10">
            <div class="mb-4">
              <img :src="block7.logo" />
            </div>
            <div>{{ block7.desc }}</div>
          </v-col>
          <v-col cols="6" md="4" class="pl-4 pl-md-10 mt-6" align="left">
            <div class="mb-5">{{ block7.product }}</div>
            <div v-for="x in block7.products" :key="x.text" class="mb-5" style="cursor: pointer" @click="GoRouter(x.url)">
              {{ x.text }}
            </div>
          </v-col>
          <v-col cols="6" md="4" class="pl-4 pl-md-10 mt-6" align="left">
            <div class="mb-5">{{ block7.company }}</div>
            <div v-for="x in block7.companys" :key="x.text" class="mb-5" style="cursor: pointer" @click="GoRouter(x.url)">
              {{ x.text }}
            </div>
          </v-col>
        </v-row>
      </v-container>
      <v-divider class="grey darken-1 mt-10 mb-10"></v-divider>
      <div class="d-lg-flex align-center justify-start px-4">
        <div class="mr-3">
          <a :href="block7.footer.text1Url" class="white--text">
            {{ block7.footer.text1 }}
          </a>
        </div>
        <div class="mr-3">{{ block7.footer.text2 }}</div>
        <div class="mr-3">{{ block7.footer.text3 }}</div>
        <div class="mr-3">{{ block7.footer.text4 }}</div>
        <div class="mr-3">{{ block7.footer.text5 }}</div>
      </div>
    </div>
    <!-- #endregion  -->

    <!-- <BottomNavigation
      v-if="$vuetify.breakpoint.width < 600"
      class="fixed-bar"
      style="z-index: 100; bottom: 0"
    /> -->
  </div>
</template>

<script>
import Header from "../components/Common/Header.vue";
// import BottomNavigation from "../components/Common/BottomNavigation.vue";

import {} from "@/apis/api";
export default {
  components: { Header },
  name: "Home",
  data() {
    return {
      lineLogo: require("@/assets/image/home/line_logo.png"),
      pfLogo: require("@/assets/image/home/pf_logo.svg"),
      logo30: require("@/assets/image/ai/金豐30.svg"),
      blockAI: [
        {
          title: "免費金豐勞動法務 AI 智能諮詢系統(人資管理的最強大腦)",
          icon: require("@/assets/image/ai/金豐ai公版icon.svg"),
          img: require("@/assets/image/ai/公版.svg"),
          list: [
            {
              text: "透過專業強大的 Al 系統，免費諮詢您的勞動權利，創造勞資雙贏！",
            },
            {
              text: "最強的人資管理 Al 大腦，免費快速得到相對應的法律內容及回答！",
            },
          ],
          footer: "免費金豐勞動法務 AI 智能諮詢系統或企業AI會員網站",
          btnText: "前往查看",
          url: process.env.VUE_APP_MAIN_AICHAT_BASE_URL,
        },
        {
          title: "企業AI行銷會員",
          icon: require("@/assets/image/ai/銀徽章.svg"),
          img: require("@/assets/image/ai/企業行銷會員.svg"),
          list: [
            {
              text: "提供企業AI名片及會員網站，成為企業或個人的超級廣告行銷利器！(提供早鳥優惠價開放預購預計2025年7月開始通知預購會員3天試用及繳費，試用期結束未繳費，視同放棄早鳥優惠價)",
            },
            {
              text: "建議適用業務性質個人或自營企業老闆",
            },
          ],
          footer: "早鳥優惠價開放預購",
          btnText: "前往查看",
          url: process.env.VUE_APP_MAIN_AICHAT_BASE_URL + "/pre-order?lv=1",
        },
        {
          title: "企業AI智庫會員",
          icon: require("@/assets/image/ai/金徽章.svg"),
          img: require("@/assets/image/ai/企業智庫會員.svg"),
          list: [
            {
              text: "提供專屬企業Al客服及智能培訓，打造24小時的無人Al客服及企業培訓系統。成為企業獲利倍增及節省大量企業培訓成本的利器！(提供早鳥優惠價開放預購，預計2025年11月開始通知預購會員3天試用及繳費，試用期結束未繳費，視同放棄早鳥優惠價）",
            },
            {
              text: "建議適用160多萬家中小企業及有銷售課程的講師或學校老師",
            },
          ],
          footer: "早鳥優惠價開放預購",
          btnText: "前往查看",
          url: process.env.VUE_APP_MAIN_AICHAT_BASE_URL + "/pre-order?lv=2",
        },
      ],
      block1: {
        bgImg: require("@/assets/image/home/PrimaryKv_bg.png"),
        title: "小芋頭平台",
        title2: "提供中小企業一站式服務",
        desc: "一個ESG企業永續發展等服務的一站式平台，為中小企業乃至個人商家提供各項解決方案",
        btnText: "免費開始",
        btnUrl: "SignUp",
        item1: "一站登入任一使用，無須重複註冊",
        item2: " 提供免費和收費方案",
        img: require("@/assets/image/home/PrimaryKv_lg_1.png"),
        // img2: require("@/assets/image/home/PrimaryKv_mdsm.png"),
        img2: process.env.VUE_APP_MAIN_BASE_URL + "/img/pre/PrimaryKv_mdsm.png",
      },
      quickForward: {
        title: "快速前往",
        items: [
          {
            text: "小芋頭社群",
            desc: "建立免費企業或社團會員網站",
            // img: require("@/assets/image/home/icon_home_tarosms.svg"),
            img: process.env.VUE_APP_MAIN_BASE_URL + "/img/pre/icon_home_tarosms.svg",
            url: process.env.VUE_APP_MAIN_SMS_BASE_URL,
          },
          {
            text: "小芋頭廣告 ",
            desc: "建立免費的社群輪播廣告",
            // img: require("@/assets/image/home/icon_home_ads.svg"),
            img: process.env.VUE_APP_MAIN_BASE_URL + "/img/pre/icon_home_ads.svg",
            url: "Ads",
          },
        ],
      },
      block11: {
        topTitle: "軟體服務全方位通道",
        topDesc: "在您需要時提供多種軟體工具，並在其中自由的移動",
      },
      block2: {
        title: "建立免費企業或社團會員網站",
        item1: "會員管理網站",
        item2: "免費使用",
        desc: "企業會員網站至少需要30萬以上的建置費用及每年的維護費用，現在您可以在小芋頭平台免費擁有，無任何費用。",
        desc2: "企業會員網站可以協助您發放最新消息，促銷您的商品活動，並累積會員數量。",
        desc3: "社團會員網站可以協助您的社團新會員快速認識其他舊會員，會長並可以將本年度的活動花絮記錄在社群網站。讓會員了解每屆會長經營會務的用心。",
        desc4: "會員網站可以（公開）也可以（不公開），方便大家管理。會員參加多個小芋頭社團網站可以方便會員共同管理及參與。",
        btnText: "免費會員網站首頁",
        btnUrl: "https://tarosms.kf-9595.com/",
        img: require("@/assets/image/home/mskv.png"),
      },
      block3: {
        img: require("@/assets/image/home/hrkv.png"),
        title: "建立企業工作站 (架構中尚未開放)",
        item1: "HR 人資軟體",
        item2: "免費使用",
        item3: "進階收費方案",
        desc: "涵蓋 8 大內容，一套完整的企業勞動法務管理的系統，雲端整合，免去所有紙本文件",
        btnText: "企業工作站首頁",
      },
      block4: {
        title: "建立免費的社群輪播廣告",
        item1: "廣告曝光",
        item2: "免費使用",
        // item3: "收費方案",
        desc: "免費企業廣告投放，讓近萬人的小芋頭免費企業及社團會員網站人員可以看到您的輪播廣告。",
        desc2: "小芋頭免費廣告可快速連結您的網頁，並提供廣告搜尋，讓您的商品被更多人看見。",
        btnText: "免費輪播廣告首頁",
        btnUrl: "Ads",
        img: require("@/assets/image/home/Adskv.png"),
      },
      block41: {
        title: "免費申請「性騷擾申訴專線」軟體及參加「企業性別意識人員培訓認證」",
        item1: "（發證單位：社團法人中華勞資法務顧問協會）",
        desc: "企業僱用10人以上就要訂定性騷擾申訴管道並公開揭示，沒有罰鍰1萬~10萬。",
        desc2: "企業僱用30人以上就要訂定性騷擾防治措施規範並公開揭示，沒有罰鍰2萬~30萬。",
        desc3: "企業只要僱用一個員工只要知悉性騷擾發生就要啟動調查處理，沒有罰鍰2萬~100萬。",
        desc4: "為了避免被罰鍰請趕快免費申請「性騷擾申訴專線」軟體！並立即參加【性騷擾防治培訓課程】，本課程為【法遵課程】，企業務必派人參加，以免受罰！",
        btnText: "免費申請性騷擾申訴專線軟體",
        btnUrl: "https://kingfong9595.blog/kingfong_oa/",
        img: require("@/assets/image/home/oakv.png"),
      },
      block42: {
        title: "免費勞動法務健檢及顧問諮詢服務",
        item1: "免費使用",
        desc: "免費提供雇主及勞工勞動法務的責任及權利的健康檢查，並提供健檢報告及評分！",
        desc2: "提供顧問師免費顧問諮詢及健檢報告說明！",
        desc3: "已經超過4萬人以上至健檢網健檢，企業合法經營，保障勞工權利，創造勞資雙贏！",
        btnText: "免費勞動法務健檢 ",
        btnUrl: "https://labor.kf-9595.com/",
        img: require("@/assets/image/home/kv.png"),
      },

      block43: {
        title: "免費法律諮詢申請及企業法律部門外包服務專案諮詢",
        item1: "免費使用",
        desc: "本服務由金豐集團合作的聯盟的律師事務所提供免費諮詢服務。",
        desc2: "人的一生中多少會面臨一些法律問題，金豐集團提供有效客戶1~2次免費法律諮詢服務。",
        desc3: "企業法律部門外包服務專案費用低廉、專業度高、服務吃到飽。",
        btnText: "免費法律諮詢及企業法律部門外包諮詢申請",
        btnUrl: "https://kingfong9595.blog/kf_lawconsult/",
        img: require("@/assets/image/home/lawkv.png"),
      },
      block44: {
        title: "免費ESG資安診斷服務申請",
        item1: "免費使用",
        desc: "本服務由金豐集團合作的華苓科技提供免費資安診斷服務。",
        desc2: "幫助企業開通線上資安評級問卷，以問卷全方面診斷企業資安現況，並提供資安顧問一次性診斷服務，配合資安矩陣方法論，讓企業檢視現況，初步防護，並依現況媒合政府資安資源及提供資安服務試用方案。",
        desc3: "免費的華苓資安系統試用申請，並提供監控報表，測試企業的資訊安全漏洞，預防駭客入侵，造成企業的嚴重損失。",
        btnText: "免費資安診斷服務申請",
        btnUrl: "http://kingfong9595.blog/information_security/",
        img: require("@/assets/image/home/InfoSec.jpg"),
      },
      block45: {
        title: "免費ESG節能減碳企業補助服務申請",
        item1: "免費使用",
        desc: "本服務由金豐集團合作的晶準企業提供免費補助申請服務。",
        desc2: "輔助中小企業申請ESG【商業服務業智慧減碳補助計畫】、【製造業低碳化及智慧化升級轉型診斷輔導計畫】申請，幫助企業減輕負擔、加速低碳化、智慧化。",
        btnText: "免費企業補助申請單",
        btnUrl: "http://kingfong9595.blog/2024esg-grant/",
        img: require("@/assets/image/home/freeESG.jpg"),
      },
      block46: {
        title: "免費企業勞動法務基礎實務考證班培訓",
        item1: "考證單位：中華民國全國工業總會：企業勞動法務人員能力鑑定考證LLA證照",
        desc: "本課程將培訓「企業勞動法務管理專業」。",
        desc2: "這是您的人生必上的一堂課，因為您不是老闆就是勞工請務必用心閱讀。",
        desc3: "完成企業勞動法務管理考證班12小時培訓之學員，可以獲得【中華民國全國工業總會】【企業勞動法務人員能力鑑定考證(LLA證照)】考證報名的考試資格!(每年5月及11月舉辦)",
        desc4: "歡迎邀約(中華民國全國工業總會勞動教育專家講師)授課培訓。",
        desc5: "本服務由金豐企管作為培訓單位。",
        btnText: "免費考證課程報名 ",
        btnUrl: "https://kingfong9595.blog/llaclass/",
        img: require("@/assets/image/home/llaclass.png"),
      },
      block47: {
        title: "金豐企業大學專家講師系列講座",
        item1: "免費講座",
        desc: "金豐企業大學於2019.2.22金豐集團高雄總部隆重成立。重點在建立新世代人力資源管理/學習系統、積極培訓精英人才、籌建知識管理體系、精實管理及勞資法務勞務管理運營。",
        desc2: "金豐企業大學專家講座系列課程提供平台所有閱讀人員免費的視訊直播課程，並於直播結束後提供錄播，讓閱讀者能深入學習專業的課程。",
        desc3: "所有專家講師課程均為系列課程，非單一課程，且對外免費公開，歡迎大家持續閱讀及分享。",
        btnText: "免費專家講師系列講座",
        btnUrl: "https://kingfong9595.blog/kingfonguniversity/",
        img: require("@/assets/image/home/kingfonguniversity.png"),
      },
      block48: {
        title: "免費ESG企業員工健康諮詢",
        item1: "免費諮詢",
        desc: "本服務由金豐集團合作的維莉娜國際芳香機構提供免費的諮詢服務。",
        desc2: "ESG企業勞工健康是企業經營在社會面（S）的重要課題之一，透過專業的課程讓企業員工身心健康，打造勞資雙贏的幸福企業。",
        btnText: "免費ESG企業員工健康諮詢",
        btnUrl: "https://kingfong9595.blog/esgform/",
        img: require("@/assets/image/home/esgform.png"),
      },
      block49: {
        title: "【企業講座】「勞動事件法及性工法及勞工職業災害保險及保護法」通過後，企業如何因應",
        item1: "免費諮詢",
        desc: "近1,000場以上的講座，每月台北、台中、台南、高雄舉辦，場場爆滿。",
        desc2: "人生必上的一場講座，因為您不是老板就是勞工，必須了解最新的勞動法律。",
        desc3: "企業被勞檢了嗎？有勞檢必有處罰，有處罰必有訴訟。",
        desc4: "價值17,000元的贈送服務，限雇主獨享。",
        btnText: "企業勞動法務管理講座報名",
        btnUrl: "http://kingfong9595.blog/0800-06-9595/",
        img: require("@/assets/image/home/Lecture.png"),
      },
      block410: {
        title: "企業勞動法務管理解決方案顧問諮詢及免費小芋頭平台專人服務",
        item1: "免費使用",
        desc: "勞資糾紛是可以預防跟解決的，企業要避免勞資糾紛，創造勞資雙贏。實現ESG的【S】員工薪資與福利，達成企業【留】才不【流】才。",
        desc2: "透過專人服務申請，企業可以了解如何解決企業經營上的勞資問題以避免處罰及訴訟危機。（本專案已經服務近7000家以上的企業）",
        desc3: "透過專人服務申請，協助大家金豐小芋頭中小企業服務平台的各項服務申請及使用。",
        btnText: "勞資爭議解決方案顧問諮詢及免費專人服務",
        btnUrl: "https://kingfong9595.blog/consulting/",
        img: require("@/assets/image/home/Consulting.png"),
      },
      block411: {
        title: "免費ESG碳盤查及認證諮詢",
        item1: "免費使用",
        desc: "本服務由金豐集團合作的德利企管公司提供免費的諮詢服務。",
        desc2: "企業為什麼要做碳盤查及碳足跡？因為台灣2050年要做到淨零排放，您的企業不做都不行。",
        btnText: "免費碳排查及認證諮詢",
        btnUrl: "https://kingfong9595.blog/esgcarbonreduction/",
        img: require("@/assets/image/home/esgcarbonreduction.png"),
      },
      block412: {
        title: "免費ESG企業綠電碳金整合計劃諮詢",
        item1: "免費諮詢",
        desc: "本服務由金豐集團合作的錦雲科技公司提供的免費諮詢服務。",
        desc2: "提供淨零減排與智慧節費的整合服務。",
        desc3: "綠電碳金-雲端電力調度控制服務光儲系統整合規劃。",
        desc4: "政府碳盤查補助專案（政府補助16萬+企業自付4萬）",
        btnText: "免費ESG企業綠電碳金整合計劃諮詢",
        btnUrl: "https://kingfong9595.blog/jincloud/",
        img: require("@/assets/image/home/jincloud.png"),
      },
      block413: {
        title: "免費ESG企業儲能電池建置及安裝諮詢",
        item1: "免費諮詢",
        desc: "本服務由金豐集團合作的江海科技公司提供的免費儲能電池建置與諮詢服務。",
        desc2: "企業深循環儲能電池產品及安裝設備及維護，企業完全免付費。",
        desc3: "如果的企業電費（高壓用電）超過30萬，只要提供電費單就可以提供服務與電力設置諮詢。",
        desc4: "透過離峰電費的儲能電池儲電，並提供高峰用電的使用，可以節省企業的電費成本費用。安裝設置完全免付費。",
        btnText: "免費ESG企業儲能電池建置及安裝諮詢",
        btnUrl: "https://kingfong9595.blog/esgjianghai/",
        img: require("@/assets/image/home/jianghai.png"),
      },
      block414: {
        title: "免費EAP員工心理健康諮詢",
        item1: "免費諮詢",
        desc: "本服務由金豐集團合作的以樂公司提供免費的諮詢服務。",
        desc2: "企業不想面對，但不得不解的員工問題。",
        desc3: "多元智能優勢測評，讓每個人因優勢而成長。",
        btnText: "免費EAP員工心理健康諮詢",
        btnUrl: "https://kingfong9595.blog/free-eap/",
        img: require("@/assets/image/home/free-EAP.svg"),
      },

      block5: {
        title: "快速註冊快速啟用",
        desc: "免費使用! 我們只會在您主動啟用進階功能時提供收費方案",
        items: [
          {
            icon: require("@/assets/image/home/Icon_home_register.svg"),
            arraw: require("@/assets/image/home/arrow.svg"),
            text: "註冊小芋頭",
            desc: "使用第3方或信箱註冊小芋頭平台",
          },
          {
            icon: require("@/assets/image/home/Icon_home _going.svg"),
            arraw: require("@/assets/image/home/arrow.svg"),
            text: "前往軟體服務",
            desc: "從小芋頭平台挑選欲使用的服務並前往",
          },
          {
            icon: require("@/assets/image/home/Icon_home _free.svg"),
            arraw: require("@/assets/image/home/arrow.svg"),
            text: "免費開始使用",
            desc: "部分服務將在首次使用時指引您完成設置",
          },
          //   {
          //     icon: require("@/assets/image/home/Icon_home _supply.svg"),
          //     arraw: require("@/assets/image/home/arrow.svg"),
          //     text: "進階收費方案",
          //     desc: "若您需要更進階的功能，我們提供收費方案供您選擇",
          //   },
        ],
      },
      block6: {
        title: "立即註冊小芋頭並開始使用免費會員網站",
        btnText: "免費開始",
        btnUrl: "SignUp",
      },
      block7: {
        logo: require("@/assets/image/home/logo.svg"),
        desc: "小芋頭是一個集結人資系統、會員網站..等服務的一站式平台，為中小企業乃至個人商家提供各項解決方案",
        product: "產品",
        products: [
          {
            text: "小芋頭平台",
            url: "https://taro.kf-9595.com/",
          },
          {
            text: "小芋頭社群",
            url: "https://tarosms.kf-9595.com/",
          },
          {
            text: "小芋頭廣告",
            url: "https://taro.kf-9595.com/ads",
          },
        ],
        company: "公司",
        companys: [
          {
            text: "顧問培訓及合作",
            url: "https://kingfong9595.blog/kf-training/",
          },
          {
            text: "聯絡我們",
            url: "https://kingfong9595.blog/contact-taro/",
          },
          {
            text: "免責聲明",
            url: "PrivacyPolicy",
          },
          {
            text: "隱私權政策",
            url: "Disclaimer",
          },
        ],
        footer: {
          text1: "© 2022 金豐企業管理顧問股份有限公司",
          text1Url: "https://www.king-fong.com/",
          text2: "﹒小芋頭工作室",
          text3: "﹒高雄市左營區大順一路91號10樓之3",
          text4: "﹒免費服務專線電話",
          text5: "﹒0800-06-9595(0800-您來-教我教我)",
        },
      },
    };
  },
  metaInfo() {
    return {
      title: "小芋頭企業服務平台",
      meta: [
        {
          name: "description",
          content: "提供中小企業一站式軟體服務",
        },
        {
          property: "og:title",
          content: "小芋頭企業服務平台",
        },
        {
          property: "og:description",
          content: "提供中小企業一站式軟體服務",
        },
        {
          property: "og:image",
          content: require("@/assets/image/home/fb_meta.png"),
        },
      ],
    };
  },
  beforeRouteUpdate(to, from, next) {
    this.$meta().refresh();
    next();
  },

  created() {
    this.$meta().refresh();
  },
  mounted() {
    this.$meta().refresh();
  },
  methods: {
    GoRouter(url) {
      if (url === "SignUp") {
        window.location.href = `signin?status=${url}`;
        return;
      }
      window.location.href = url;
    },
    AddLine() {
      let newWindow = window.open();
      newWindow.location.href = "https://lin.ee/l07cEKr";
    },
    GoBlank(url) {
      const newWin = window.open();
      newWin.location.href = url;
    },
  },
};
</script>

<style scoped>
.block1-bg {
  background: #e9deff;
  background-image: url("~@/assets/image/home/PrimaryKv_bg.png");
  height: 478px;
  background-repeat: no-repeat;
  background-position: top right;
  /* background-size: contain; */
}
@media screen and (max-width: 1280px) {
  .block1-bg {
    height: 538px;
  }
}
@media screen and (max-width: 960px) {
  .block1-bg {
    height: auto;
  }
}
.v-card {
  transition: opacity 0.2s ease-in-out;
  opacity: 0.8;
}

.v-card:not(.on-hover) {
  opacity: 1;
}
.quick-go {
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 12px;
  cursor: pointer;
}
@media screen and (max-width: 600px) {
  .quick-go {
    border: none;
  }
}

.shareBtn {
  border-radius: 500px;
  border: 1px;
  background: #ffffff;
  border: 1px solid var(--color-Primary-theme-1, #7c4dff);
}

.home-subtitle {
  background: linear-gradient(90deg, rgba(63, 13, 202, 0.87) 0%, rgba(0, 81, 255, 0.87) 83.09%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.home-block {
  max-width: 1280px;
  width: 100%;
  justify-content: center;
  align-items: center;
  gap: 24px;
  padding: 16px 24px;
  border-radius: 80px 80px 0 0;
  background: linear-gradient(180deg, #d7eeff 0%, #fff 100%);
}

@media screen and (max-width: 600px) {
  .home-block {
    border-radius: 40px 40px 0 0;
  }
}

.home-block-icon-bg {
  display: flex;
  padding: var(--spacing-2-8, 8px) var(--spacing-4-16, 16px);
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: var(--spacing-7-28, 28px);
  background: #fff;
}

.ai-title {
  color: var(--color-Primary-title, #4934a6);
  font-size: 31px;
  font-style: normal;
  font-weight: 700;
  line-height: 150%; /* 46.5px */
  letter-spacing: 0.25px;
}

@media screen and (max-width: 600px) {
  .ai-title {
    font-size: 23px;
  }
}

.ai-sub {
  color: var(--color-text-primary-87, rgba(0, 0, 0, 0.87));
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%; /* 27px */
  letter-spacing: 0.25px;
}

.ai-card {
  border-radius: 12px;
  border: 1px solid var(--blue-grey-blue-grey-lighten-5, #eceff1);
  background: linear-gradient(180deg, #fff 0%, #d7eeff 100%);
}
</style>
